export default __webpack_public_path__ + "images/truck-7e6a0d433c385cda29dcd95329596ae2.png";